import { i18n } from '@/boot/i18n';
import removeMask from '@/utils/removeMask';
import ErrorHandler from '@/tools/errorHandler';
import { setSentryUser } from '@/boot/sentry'; // eslint-disable-line
import { validators } from './validators';
import * as types from './mutationTypes';
import ProfileService from '../../../services/profile';

export default {
  initUpdateState({ dispatch, commit, state }) {
    commit(types.SET_PROFILE_EDIT, { ...state.profile });

    const validator = validators();
    dispatch('validator/addValidator', validator.name, { root: true });
    dispatch('validator/addValidator', validator.code, { root: true });
    dispatch('validator/addValidator', validator.phone, { root: true });
  },
  clearUpdateState({ dispatch, commit }) {
    commit(types.CLEAR_PROFILE_EDIT);
    dispatch('validator/clearValidator', null, { root: true });
  },
  clearProfile({ commit }) {
    commit(types.CLEAR_PROFILE);
  },
  async getOne({ commit, rootState }) {
    const profile = await ProfileService.getOne();
    if (profile.data.data) {
      commit(types.SET_PROFILE, profile.data.data);

      const { email, name, uuid } = profile.data.data;
      const { name: organization = null } = rootState.organization.organization || {};

      setSentryUser({
        email, name, uuid, organization,
      });
    }
  },
  async update({ commit, dispatch, state }) {
    const valid = await dispatch('validateUpdate');
    if (!valid) {
      return;
    }
    try {
      const data = { ...state.profileEdit };
      data.phone = Number(removeMask(data.phone));

      const response = await ProfileService.update(data);
      if (response.data.data) {
        commit(types.SET_PROFILE, response.data.data);
      }
      dispatch('ui/showToastSuccess', i18n.t('profile.messages.profile_save_success'), { root: true });
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async updateSettings({ commit, dispatch, state }) {
    try {
      const data = {
        uuid: state.profileEdit.uuid,
        primary_language: state.profileEdit.primary_language,
        primary_time_offset: state.profileEdit.primary_time_offset,
      };
      const response = await ProfileService.updateSettings(data);
      if (response.data.data) {
        commit(types.SET_PROFILE, response.data.data);
      }
      dispatch('ui/showToastSuccess', i18n.t('profile.messages.profile_save_success'), { root: true });
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
    }
  },

  setEditField({ commit, dispatch }, { field, value }) {
    commit(types.SET_EDIT_FIELD, { field, value });
    dispatch('validator/checkValidation', { field, value }, { root: true });
  },

  validateUpdate({ dispatch, state, rootState }) {
    dispatch('validator/validate', { field: 'name', value: state.profileEdit.name }, { root: true });
    dispatch('validator/validate', { field: 'phone', value: state.profileEdit.phone }, { root: true });
    dispatch('validator/validate', { field: 'country_code', value: state.profileEdit.country_code }, { root: true });
    return rootState.validator.errors?.length === 0;
  },
  async getProfileFromStorage({ commit }) {
    const data = await localStorage.getItem('t-profile');
    const profile = await JSON.parse(data);
    commit(types.SET_PROFILE, profile);
  },
};
